import React, { Component } from "react";

class Giftvoucher extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <a href="Default.aspx" className="a-breadcrumbs">หน้าแรก</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="Purpose.aspx" className="a-breadcrumbs">บัตรกำนัล</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-sm-9 mb-sm-50" style={{fontFamily: '"Cordia New"', fontSize: 20}}>
              {/* section title*/}
              <h2 className="title-section mt-0 mb-0"><span>บัตรกำนัล</span></h2><br/>
              {/* ! section title*/}
              <div className="divider gray left mt-20 mb-25" />
              <p className="mb-20">หากมีความประสงค์จะซื้อบัตรกำนัล</p>
              {/* list*/}
              <ul className="mb-25">
                <li>1. ดาวน์โหลดแบบฟอร์มขอซื้อบัตรกำนัลและกรอกรายละเอียดให้ครบถ้วน <a href="Form/ใบคำร้องขอซื้อบัตรกำนัล.pdf" target="_blank" style={{color: '#0094ff'}}>คลิกเพื่อดาวน์โหลดแบบฟอร์ม</a> </li>
                <li>2. ติดต่อขอซื้อบัตรกำนัลได้ที่อาคารภูไบ (กรณีสั่งซื้อเกิน 30 ใบ ต้องสั่งล่วงหน้า 10 วันทำการ)</li>
                <li>3. รับบัตรกำนัลและชำระเงินตามจำนวนที่สั่งซื้อพร้อมค่าธรรมเนียมเนียม ฉบับละ 5 บาท</li>
              </ul>
              <a href="Img/Board/gift-voucher-1024x409.png" target="_blank"><img src="Img/Board/gift-voucher-1024x409.png" /></a>
              <br/>
              <br/>
              <br/>
            </div>
          </div>
        </div>
        </section>
      </div>
    );
  }
}

export default Giftvoucher;
